import { render, staticRenderFns } from "./ShoppingCar.vue?vue&type=template&id=0f7511d8&scoped=true&"
import script from "./ShoppingCar.vue?vue&type=script&lang=js&"
export * from "./ShoppingCar.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0f7511d8",
  null
  
)

component.options.__file = "ShoppingCar.vue"
export default component.exports